export function StatusRenderer({ value}) {
  if (!value) {
    return null;
  }
  
  const statusMap = {
    DRAFT: "badge bg-secondary",
    REVIEW: "badge bg-warning",
    REJECTED: "badge bg-danger",
    LIVE: "badge bg-success",
    ACTIVE: "badge bg-success",
    APPROVED: "badge bg-success",
    PAUSED: "badge bg-warning",
    NOT_BIDDING: "badge bg-danger",
    "NOT BIDDING": "badge bg-danger",
    INACTIVE: "badge bg-danger",
    INHERITED: "badge bg-warning",
  };

  const status = value.toUpperCase();

  let className = statusMap[status];

  return className ? <span className={className}>{status.charAt(0) + status.slice(1).toLowerCase()}</span> : null;
}
